const typeOfTrucks = [
  {
    label: 'Все типы транспорта',
    value: 'all_types_trucks',
  },
  {
    label: 'Грузовики',
    value: 'truck',
  },
  {
    label: 'Тягачи',
    value: 'tractor',
  },
  {
    label: 'Прицепы',
    value: 'trailer',
  },
  {
    label: 'Полуприцепы',
    value: 'semitrailer',
  },
  {
    label: 'Автопоезда',
    value: 'road_train',
  },
  {
    label: 'Автобусы',
    value: 'bus',
  },
  {
    label: 'Автокраны',
    value: 'truck_crane',
  },
  {
    label: 'Экскаваторы',
    value: 'excavator',
  },
  {
    label: 'Бульдозеры',
    value: 'dozer',
  },
  {
    label: 'Погрузчики',
    value: 'loader',
  },
  {
    label: 'Спецтехника (другое)',
    value: 'other_special',
  },
];

export default typeOfTrucks;
